class HomeController {
  constructor() {
  }
}

HomeController.$inject = []

module.exports = HomeController



// WEBPACK FOOTER //
// ./src/app/pages/home/home.controller.js